import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMsal } from '@azure/msal-react';
import './AlertConfig.css';
import axios from 'axios';
import Modal from 'react-modal';
import AlertTypeModal from '../Modal/AlertTypeModal';
import DateTimeRow from '../Modal/DateTimeRow';
import StatusTableCell from '../LogTableComponents/StatusTableCell';
import { getLocaleDateTime } from '../../helpers/dateTimeHelper';
import { getApiKey } from '../../helpers/stringHelpers';

function AlertConfig({ config }) {
    const { accounts, instance } = useMsal();

    const userEmail = accounts.length > 0 ? accounts[0].username : '';
    const logmsgApiUrl = config.logMsgApiUrl;
    const logmsgApiKey = getApiKey(config.enviromentScope);

    // Init Component with UseEffect
    useEffect(() => {
        fetchAllAlertConfigs();
        fetchAllAlertTypes();
        Modal.setAppElement('#root');
    }, []); // Empty dependency array to run the effect only once when the component is mounted

    // Init States
    const [error, setError] = useState(null);
    const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
    const [modalAction, setModalAction] = useState("");

    const [allAlertConfigs, setAllAlertConfigs] = useState([]);

    const [allAlertTypes, setAllAlertTypes] = useState([]);
    const [newAlertType, setNewAlertType] = useState({
        alertType: 'topdesk',
        alertValue: 'topdesk',
        description: 'Send to Topdesk',
        status: 'Ok',
        timeStamp: '2024-04-25T08:42:14.679Z'
    });
    const [currentAlertType, setCurrentAlertType] = useState({
        alertType: '',
        alertValue: '',
        description: '',
        status: '',
        timeStamp: ''
    });


    // Functions

    // Open Add/Modify Alert Type Modal
    const openTypeModal = (type, alertType = newAlertType) => {
        setCurrentAlertType(alertType);
        setIsTypeModalOpen(true);
        setModalAction(type);
    };

    // Close Add/Modify Alert Config Modal
    const closeTypeModal = () => {
        setIsTypeModalOpen(false);
        setError(null);
        // Reset newAlertType state when modal is closed (will be ready for next add)
        setNewAlertType({
            alertType: 'topdesk',
            alertValue: 'topdesk',
            description: 'Send to Topdesk',
            status: 'Ok',
            timeStamp: '2024-04-25T08:42:14.679Z'
        });
    };

    // Get a list of all the AlertConfigs from the LogMsg API
    const fetchAllAlertConfigs = () => {
        const applicationId = config.clientId;

        const accessTokenRequest = {
            scopes: ["api://" + applicationId + "/User.Read"],
            account: accounts[0],
        };
        instance
            .acquireTokenSilent(accessTokenRequest)
            .then((accessTokenResponse) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;

                let getRequest = logmsgApiUrl + '/AlertConfigGetAll';

                // Setup Header
                const headers = {
                    'Authorization': 'Bearer ' + accessToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKEY': logmsgApiKey
                };


                // Make the API request
                axios.get(getRequest, {
                    headers: headers
                })
                    .then((response) => {
                        // Set the fetched data sorted by rule name
                        var alertConfigsFromApi = response.data;
                        alertConfigsFromApi.sort((a, b) => (a.alertNameUnique || '').localeCompare(b.alertNameUnique || ''));
                        setAllAlertConfigs(alertConfigsFromApi)
                    })
                    .catch((error) => {
                        console.error('AlertConfig fetch failed:', error);
                    });
            })
            .catch((error) => {
                console.error('AlertConfig token acquisition failed:', error);
            });
    };

    // Get a list of all the AlertTypes from the LogMsg API
    const fetchAllAlertTypes = () => {
        const applicationId = config.clientId;

        const accessTokenRequest = {
            scopes: ["api://" + applicationId + "/User.Read"],
            account: accounts[0],
        };
        instance
            .acquireTokenSilent(accessTokenRequest)
            .then((accessTokenResponse) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;

                let getRequest = logmsgApiUrl + '/AlertTypeGetAll';

                // Setup Header
                const headers = {
                    'Authorization': 'Bearer ' + accessToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKEY': logmsgApiKey
                };

                // Make the API request
                axios.get(getRequest, {
                    headers: headers
                })
                    .then((response) => {
                        // Set the fetched data to the logMessageTable variable
                        var alertTypesFromApi = response.data;
                        setAllAlertTypes(alertTypesFromApi)
                    })
                    .catch((error) => {
                        console.error('AlertType fetch failed:', error);
                    });
            })
            .catch((error) => {
                console.error('AlertType token acquisition failed:', error);
            });
    };

    const handleChangedAlertConfig = (currentAlertConfig, action) => {
        const applicationId = config.clientId;

        const accessTokenRequest = {
            scopes: ["api://" + applicationId + "/User.Read"],
            account: accounts[0],
        };
        instance
            .acquireTokenSilent(accessTokenRequest)
            .then((accessTokenResponse) => {

                let accessToken = accessTokenResponse.accessToken;

            // Make the API request to insert or modify a AlertConfig
            let postRequest = logmsgApiUrl;

            if (action === "Modify") {
                postRequest += '/AlertConfigModify';
            } else if (action === "Add") {
                postRequest += '/AlertConfigInsert';
            }

            // Set parameter for post request
            const params = {
                ID: currentAlertConfig.ID,
                alertNameUnique: currentAlertConfig.alertNameUnique,
                alertType: currentAlertConfig.alertType,
                alertFrequencyInMin: currentAlertConfig.alertFrequencyInMin,
                alertSendMaxMsgs: currentAlertConfig.alertSendMaxMsgs,
                alertStartTime: currentAlertConfig.alertStartTime,
                alertFilter: currentAlertConfig.alertFilter,
                alertAggregateMsgs: currentAlertConfig.alertAggregateMsgs || null,
                description: currentAlertConfig.description || null,
                alternative: currentAlertConfig.alternative || null,
                lastRunStatus: currentAlertConfig.lastRunStatus || null,
                Upn: userEmail
            };

            // Only include optional datetime params when they have a value
            params.alertEndTime = currentAlertConfig.alertEndTime || null;
            params.lastRun = currentAlertConfig.lastRun || null;

                    const requestHeaders = {
                        'Authorization': 'Bearer ' + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'APIKEY': logmsgApiKey,
            };

            // Post newAlertConfig to LogMsgAPI
            axios.post(postRequest, null, { headers: requestHeaders, params: params })
                .then(() => {
                    // Exit edit/add mode
                    cancelEditing();
                    cancelAdding();

                    // Fetch the updated list of AlertConfig
                    fetchAllAlertConfigs();
                })
                .catch((exc) => {
                    // Handle errors
                    console.error('AlertConfig save failed:', exc);
                    const errMsg = exc.response?.data?.Error || exc.message;
                    setError(errMsg);
                    setEditValidationError(errMsg);
                    setAddValidationError(errMsg);
                }
                    );
            })
            .catch((error) => {
                console.error('AlertConfig save token acquisition failed:', error);
            });
    };

    const handleChangedAlertType = (currentAlertType, action) => {
        const applicationId = config.clientId;

        const accessTokenRequest = {
            scopes: ["api://" + applicationId + "/User.Read"],
            account: accounts[0],
        };
        instance
            .acquireTokenSilent(accessTokenRequest)
            .then((accessTokenResponse) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;

                // Make the API request to insert or modify a AlertType
                let postRequest = logmsgApiUrl;

                if (action === "Modify") {
                    postRequest += '/AlertTypeModify';
                } else if (action === "Add") {
                    postRequest += '/AlertTypeInsert';
                }

                // Set parameter for post request
                const params = {
                    ID: currentAlertType.ID,
                    alertType: currentAlertType.alertType,
                    alertValue: currentAlertType.alertValue,
                    description: currentAlertType.description,
                    status: currentAlertType.status,
                    timeStamp: currentAlertType.timeStamp
                };

                const requestHeaders = {
                    'Authorization': 'Bearer ' + accessToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'APIKEY': logmsgApiKey,
                };

                // Post newAlertType to LogMsgAPI
                axios.post(postRequest, null, { headers: requestHeaders, params: params })
                    .then(() => {
                        // Close the modal
                        closeTypeModal();

                        // Fetch the updated list of AlertType
                        fetchAllAlertTypes();
                    })
                    .catch((exc) => {
                        // Handle errors
                        console.error('AlertType save failed:', exc);
                        setError(exc.response?.data?.Error || exc.message);
                    }
                );
            })
            .catch((error) => {
                console.error('AlertType save token acquisition failed:', error);
            });
    };

    const [expandedConfigs, setExpandedConfigs] = useState({});

    const toggleConfigExpand = (index) => {
        setExpandedConfigs(prev => ({ ...prev, [index]: !prev[index] }));
    };

    // Inline edit mode state
    const [editingIndex, setEditingIndex] = useState(null);
    const [editAlertConfig, setEditAlertConfig] = useState(null);
    const [originalAlertConfig, setOriginalAlertConfig] = useState(null);
    const [editValidationError, setEditValidationError] = useState('');

    // Inline add mode state
    const [isAdding, setIsAdding] = useState(false);
    const [addAlertConfig, setAddAlertConfig] = useState(null);
    const addDefaults = {
        alertNameUnique: '',
        alertType: 'topdesk',
        alertFrequencyInMin: '1440',
        alertSendMaxMsgs: '1',
        alertAggregateMsgs: '',
        alertStartTime: new Date().toISOString(),
        alertEndTime: '',
        alertFilter: '',
        description: '',
        alternative: '',
        lastRunStatus: '',
        lastRun: ''
    };
    const [addValidationError, setAddValidationError] = useState('');

    const startAdding = () => {
        setAddAlertConfig({ ...addDefaults });
        setIsAdding(true);
        setAddValidationError('');
        // Cancel any active edit
        cancelEditing();
    };

    const cancelAdding = () => {
        setIsAdding(false);
        setAddAlertConfig(null);
        setAddValidationError('');
    };

    const handleAddField = (field, value) => {
        setAddAlertConfig(prev => ({ ...prev, [field]: value }));
        setAddValidationError('');
    };

    const isAddValid = () => {
        if (!addAlertConfig) return false;
        return addAlertConfig.alertNameUnique.trim() !== '' && addAlertConfig.alertStartTime !== '';
    };

    const handleInlineAdd = () => {
        if (!addAlertConfig.alertNameUnique.trim()) {
            setAddValidationError('Rule Name is required.');
            return;
        }
        if (!addAlertConfig.alertStartTime || isNaN(new Date(addAlertConfig.alertStartTime).getTime())) {
            setAddValidationError('Rule Start Time is required and must be a valid date.');
            return;
        }
        if (addAlertConfig.alertEndTime && isNaN(new Date(addAlertConfig.alertEndTime).getTime())) {
            setAddValidationError('Rule End Time is not a valid date.');
            return;
        }
        setAddValidationError('');
        handleChangedAlertConfig(addAlertConfig, "Add");
    };

    const startEditing = (index, alertConfig) => {
        // Normalize null values to empty strings for controlled inputs
        const normalized = Object.fromEntries(
            Object.entries(alertConfig).map(([key, val]) => [key, val ?? ''])
        );
        setEditAlertConfig(normalized);
        setOriginalAlertConfig(normalized);
        setEditingIndex(index);
        setEditValidationError('');
        // Expand the row if not already
        setExpandedConfigs(prev => ({ ...prev, [index]: true }));
    };

    const cancelEditing = () => {
        setEditingIndex(null);
        setEditAlertConfig(null);
        setOriginalAlertConfig(null);
        setEditValidationError('');
    };

    const isDirty = () => {
        if (!editAlertConfig || !originalAlertConfig) return false;
        return Object.keys(originalAlertConfig).some(key => editAlertConfig[key] !== originalAlertConfig[key]);
    };

    const handleEditField = (field, value) => {
        setEditAlertConfig(prev => ({ ...prev, [field]: value }));
        setEditValidationError('');
    };

    const handleInlineSave = () => {
        // Validate required date: alertStartTime
        if (!editAlertConfig.alertStartTime || isNaN(new Date(editAlertConfig.alertStartTime).getTime())) {
            setEditValidationError('Rule Start Time is required and must be a valid date.');
            return;
        }
        if (editAlertConfig.alertEndTime && isNaN(new Date(editAlertConfig.alertEndTime).getTime())) {
            setEditValidationError('Rule End Time is not a valid date.');
            return;
        }
        if (editAlertConfig.lastRun && isNaN(new Date(editAlertConfig.lastRun).getTime())) {
            setEditValidationError('Rule Last Run Time is not a valid date.');
            return;
        }
        // Warn if lastRun is being cleared
        if (!editAlertConfig.lastRun && originalAlertConfig.lastRun) {
            if (!window.confirm("Rule Last Run Time is empty. This will reset the alert collection window. Are you sure?")) {
                return;
            }
        }
        setEditValidationError('');
        handleChangedAlertConfig(editAlertConfig, "Modify");
    };

    return (
        <div className="AlertConfig">
            <div className="AlertConfigs">
                <h2>Alert Rules</h2>
                <p>
                    Alert rules monitor incoming log messages and send notifications when messages match your filter.
                    Each rule checks for new matches at a set interval based on the frequency you configure.
                </p>
                <details className="alert-help-details">
                    <summary>More details</summary>
                    <ul>
                        <li><strong>Rule Name</strong> — a unique identifier for this rule. Used to track runs and link to a destination.</li>
                        <li><strong>Alert Type</strong> — the name of a destination (defined in Alert Destinations below) that receives the notification.</li>
                        <li><strong>Query Filter</strong> — defines which log messages to match. Filter on [sender], [receiver], [transactionType], [messageType], [transactionTag], [description], [fileName], or [status] using <code>=</code> or <code>like '%text%'</code>. You can combine multiple filters with <code>and</code>.</li>
                        <li><strong>Frequency</strong> — how often the rule checks for new matches, in minutes (e.g. 1440 = once per day).</li>
                        <li><strong>Min Msg Count</strong> — the minimum number of matching messages needed before a notification is sent.</li>
                        <li><strong>Aggregate Msgs</strong> — how many messages to bundle into a single notification. Leave empty to send one notification per match.</li>
                        <li><strong>Rule Start / End Time</strong> — the time window during which the rule is active. Leave end time empty for an open-ended rule.</li>
                        <li><strong>Subject / Brief Description</strong> — used as the email subject line or TopDesk incident title.</li>
                        <li><strong>Alternative Body</strong> — optional custom notification body. Supports variable substitution like [transactionTag] or [sender].</li>
                        <li><strong>Last Run Time</strong> — the last time this rule checked for messages. Edit this to re-scan older messages.</li>
                        <li><strong>Last Run Status</strong> — shows whether the last run succeeded (Ok) or encountered an error.</li>
                        <li>The system checks for new matches every 5 minutes. The frequency setting controls how often a notification is actually sent.</li>
                    </ul>
                </details>

                {!isAdding && (
                    <button onClick={startAdding}>Add new Alert Rule</button>
                )}

                {isAdding && (
                    <div className="alert-config-item adding">
                        <div className="alert-config-summary" style={{ cursor: 'default' }}>
                            <span className="alert-config-name">New Alert Rule</span>
                        </div>
                        <div className="alert-config-details">
                            {addValidationError && (
                                <div className="edit-validation-error">{addValidationError}</div>
                            )}
                            <div className="alert-config-detail-grid">
                                <div className="detail-item">
                                    <span className="detail-label">Rule Name</span>
                                    <input type="text" className="detail-edit-input" value={addAlertConfig.alertNameUnique} onChange={(e) => handleAddField('alertNameUnique', e.target.value)} placeholder="Unique rule name" />
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Alert Type</span>
                                    <input type="text" className="detail-edit-input" value={addAlertConfig.alertType} onChange={(e) => handleAddField('alertType', e.target.value)} />
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Frequency (min)</span>
                                    <input type="text" className="detail-edit-input" value={addAlertConfig.alertFrequencyInMin} onChange={(e) => handleAddField('alertFrequencyInMin', e.target.value)} />
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Min Msg Count</span>
                                    <input type="text" className="detail-edit-input" value={addAlertConfig.alertSendMaxMsgs} onChange={(e) => handleAddField('alertSendMaxMsgs', e.target.value)} />
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Aggregate Msgs</span>
                                    <input type="text" className="detail-edit-input" value={addAlertConfig.alertAggregateMsgs} onChange={(e) => handleAddField('alertAggregateMsgs', e.target.value)} />
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Rule Start Time</span>
                                    <DateTimeRow value={addAlertConfig.alertStartTime} onChange={(val) => handleAddField('alertStartTime', val)} placeholderText="Select start time" />
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Rule End Time</span>
                                    <DateTimeRow value={addAlertConfig.alertEndTime} onChange={(val) => handleAddField('alertEndTime', val)} placeholderText="No end time (optional)" />
                                </div>
                            </div>
                            <div className="detail-item detail-full">
                                <span className="detail-label">Query Filter</span>
                                <textarea className="detail-edit-textarea" value={addAlertConfig.alertFilter} onChange={(e) => handleAddField('alertFilter', e.target.value)} rows={3} placeholder="[transactionType] ='Employee' and [status]='Error'" />
                            </div>
                            <div className="detail-item detail-full">
                                <span className="detail-label">Subject / Brief Description</span>
                                <input type="text" className="detail-edit-input" value={addAlertConfig.description} onChange={(e) => handleAddField('description', e.target.value)} placeholder="Alert description" />
                            </div>
                            <div className="detail-item detail-full">
                                <span className="detail-label">Alternative Body</span>
                                <textarea className="detail-edit-textarea" value={addAlertConfig.alternative} onChange={(e) => handleAddField('alternative', e.target.value)} rows={2} placeholder="Optional alternative body" />
                            </div>
                            <div className="edit-actions">
                                <button className="edit-save-btn" onClick={handleInlineAdd} disabled={!isAddValid()}>Add</button>
                                <button className="edit-cancel-btn" onClick={cancelAdding}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="alert-config-list">
                    {allAlertConfigs.map((alertConfig, index) => {
                        const isEditing = editingIndex === index;
                        const cfg = isEditing ? editAlertConfig : alertConfig;

                        return (
                        <div key={index} className={`alert-config-item ${isEditing ? 'editing' : ''}`}>
                            <div className="alert-config-summary" onClick={() => { if (!isEditing) toggleConfigExpand(index); }}>
                                <span className="alert-config-toggle">{expandedConfigs[index] ? '▼' : '▶'}</span>
                                <span className="alert-config-name">{alertConfig.alertNameUnique}</span>
                                <span className="alert-config-lastrun">Last Run Time: {getLocaleDateTime(alertConfig.lastRun) || '—'}</span>
                                {!isEditing && (
                                    <button className="alert-config-modify-btn" onClick={(e) => { e.stopPropagation(); startEditing(index, alertConfig); }}>Edit</button>
                                )}
                            </div>
                            {expandedConfigs[index] && (
                                <div className="alert-config-details">
                                    {isEditing && editValidationError && (
                                        <div className="edit-validation-error">{editValidationError}</div>
                                    )}
                                    <div className="alert-config-detail-grid">
                                        <div className="detail-item">
                                            <span className="detail-label">Rule Name</span>
                                            {isEditing ? (
                                                <input type="text" className="detail-edit-input" value={cfg.alertNameUnique} onChange={(e) => handleEditField('alertNameUnique', e.target.value)} />
                                            ) : (
                                                <span className="detail-value">{cfg.alertNameUnique}</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Alert Type</span>
                                            {isEditing ? (
                                                <input type="text" className="detail-edit-input" value={cfg.alertType} onChange={(e) => handleEditField('alertType', e.target.value)} />
                                            ) : (
                                                <span className="detail-value">{cfg.alertType}</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Last Run Status</span>
                                            <span className={`detail-value ${cfg.lastRunStatus === 'Ok' ? 'status-ok' : cfg.lastRunStatus ? 'status-error' : ''}`}>
                                                {cfg.lastRunStatus || '—'}
                                            </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Frequency (min)</span>
                                            {isEditing ? (
                                                <input type="text" className="detail-edit-input" value={cfg.alertFrequencyInMin} onChange={(e) => handleEditField('alertFrequencyInMin', e.target.value)} />
                                            ) : (
                                                <span className="detail-value">{cfg.alertFrequencyInMin} min</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Min Msg Count</span>
                                            {isEditing ? (
                                                <input type="text" className="detail-edit-input" value={cfg.alertSendMaxMsgs} onChange={(e) => handleEditField('alertSendMaxMsgs', e.target.value)} />
                                            ) : (
                                                <span className="detail-value">{cfg.alertSendMaxMsgs}</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Aggregate Msgs</span>
                                            {isEditing ? (
                                                <input type="text" className="detail-edit-input" value={cfg.alertAggregateMsgs} onChange={(e) => handleEditField('alertAggregateMsgs', e.target.value)} />
                                            ) : (
                                                <span className="detail-value">{cfg.alertAggregateMsgs || '—'}</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Rule Start Time</span>
                                            {isEditing ? (
                                                <DateTimeRow value={cfg.alertStartTime} onChange={(val) => handleEditField('alertStartTime', val)} placeholderText="Select start time" />
                                            ) : (
                                                <span className="detail-value">{getLocaleDateTime(cfg.alertStartTime) || '—'}</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Rule End Time</span>
                                            {isEditing ? (
                                                <DateTimeRow value={cfg.alertEndTime} onChange={(val) => handleEditField('alertEndTime', val)} placeholderText="No end time (optional)" />
                                            ) : (
                                                <span className="detail-value">{getLocaleDateTime(cfg.alertEndTime) || '—'}</span>
                                            )}
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">Last Run Time</span>
                                            {isEditing ? (
                                                <DateTimeRow value={cfg.lastRun} onChange={(val) => handleEditField('lastRun', val)} placeholderText="No last run (optional)" />
                                            ) : (
                                                <span className="detail-value">{getLocaleDateTime(cfg.lastRun) || '—'}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="detail-item detail-full">
                                        <span className="detail-label">Query Filter</span>
                                        {isEditing ? (
                                            <textarea className="detail-edit-textarea" value={cfg.alertFilter} onChange={(e) => handleEditField('alertFilter', e.target.value)} rows={3} />
                                        ) : (
                                            <span className="detail-value detail-code">{cfg.alertFilter}</span>
                                        )}
                                    </div>
                                    <div className="detail-item detail-full">
                                        <span className="detail-label">Subject / Brief Description</span>
                                        {isEditing ? (
                                            <input type="text" className="detail-edit-input" value={cfg.description} onChange={(e) => handleEditField('description', e.target.value)} />
                                        ) : (
                                            <span className="detail-value">{cfg.description || '—'}</span>
                                        )}
                                    </div>
                                    <div className="detail-item detail-full">
                                        <span className="detail-label">Alternative Body</span>
                                        {isEditing ? (
                                            <textarea className="detail-edit-textarea" value={cfg.alternative} onChange={(e) => handleEditField('alternative', e.target.value)} rows={2} />
                                        ) : (
                                            cfg.alternative ? <span className="detail-value">{cfg.alternative}</span> : <span className="detail-value">—</span>
                                        )}
                                    </div>
                                    {!isEditing && (
                                        <div className="detail-item detail-full">
                                            <span className="detail-label">Last Modified By</span>
                                            <span className="detail-value">{alertConfig.upn || '—'}</span>
                                        </div>
                                    )}
                                    {isEditing && (
                                        <div className="edit-actions">
                                            <button className="edit-save-btn" onClick={handleInlineSave} disabled={!isDirty()}>Save</button>
                                            <button className="edit-cancel-btn" onClick={cancelEditing}>Cancel</button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        );
                    })}
                </div>
            </div>

            <div className="AlertType">
                <h2>Alert Destinations</h2>
                <p>
                    Destinations control where notifications are delivered. Each alert rule references a destination by name.
                    Supported channels are email and TopDesk.
                </p>
                <details className="alert-help-details">
                    <summary>More details</summary>
                    <ul>
                        <li><strong>Alert Type</strong> — the destination name. Must start with <code>mail_</code> for email or <code>topdesk_</code> for TopDesk incidents. This is the value referenced by alert rules.</li>
                        <li><strong>Alert Value / Receiver</strong> — the actual recipient. For email: one or more addresses separated by <code>;</code>. For TopDesk: a caller identifier or email.</li>
                        <li><strong>Description</strong> — a short label explaining what this destination is for (e.g. "IT Operations team email").</li>
                        <li><strong>Status</strong> — shows whether the destination is working (Ok) or has an issue.</li>
                        <li><strong>TimeStamp</strong> — when this destination was last modified.</li>
                        <li>For <code>topdesk_</code> destinations: if the value ends with @odfjell.com, that user is set as the TopDesk caller and receives an incident email.</li>
                        <li>All notification emails are sent from the Helpdesk mailbox, with a copy kept in the Sent folder.</li>
                    </ul>
                </details>

                <button onClick={() => openTypeModal("Add")}>Add new Alert Destination</button>

                <table>
                    <thead>
                        <tr>
                            <th style={{ maxWidth: "40px" }}>Alert Type</th>
                            <th style={{ maxWidth: "40px" }}>Alert Value/Reciver</th>
                            <th style={{ maxWidth: "60px" }}>Description</th>
                            <th style={{ maxWidth: "60px" }}>Status</th>
                            <th style={{ maxWidth: "60px" }}>TimeStamp</th>
                            <th style={{ maxWidth: "60px" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allAlertTypes.map((alertType, index) => (
                            <tr key={index}>
                                <td style={{ maxWidth: "40px" }}>{alertType.alertType}</td>
                                <td style={{ maxWidth: "40px" }}>{alertType.alertValue}</td>
                                <td style={{ maxWidth: "40px" }}>{alertType.description}</td>
                                <StatusTableCell status={alertType.status} style={{ maxWidth: "40px" }} />
                                <td style={{ maxWidth: "40px" }}>{getLocaleDateTime(alertType.timeStamp)}</td>

                                <td style={{ maxWidth: "40px" }}>
                                    <button onClick={() => openTypeModal("Modify", alertType)}>Modify</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Modal for adding or modifying AlertType */}
                <AlertTypeModal
                    isOpen={isTypeModalOpen}
                    onRequestClose={closeTypeModal}
                    action={modalAction}
                    alertType={currentAlertType}
                    onClose={closeTypeModal}
                    error={error}
                    handleChangedAlertTypeCallback={handleChangedAlertType}
                />
            </div>
        </div>
    );
}

AlertConfig.propTypes = {
    config: PropTypes.shape({
        clientId: PropTypes.string.isRequired,
        logMsgApiUrl: PropTypes.string.isRequired,
        enviromentScope: PropTypes.string.isRequired,
    }).isRequired,
};

export default AlertConfig;
